<template>


    <div v-if="showModal" id='modal-container' @keyup.esc="showModal = false" tabindex="0">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-dialog d-flex flex-column align-content-center" role="document">
                        <div class="modal-content"  style='z-index: 10'>
                            
                            <div class="modal-header">
                                <h5 class="modal-title">{{ title }} - {{sensor_photo}}</h5>

                                <button type="button" id='close-button' class="close" data-dismiss="modal" aria-label="Close" @click="showModal = false" ref="closer">
                                    <span class='ti-close'></span>
                                </button>     
                                
                            </div>

                            <!-- <p><a :href="link" target="frame">Open RDP</a></p> -->
                            
                            <div class="modal-body overflow-auto" style='width: 100%; height: 73vh; '>


                                <div style='background-color: #2a2a2e; padding: 20px; height: 100%;'>
                                    <div id='spinner-loading' class="d-flex justify-content-center align-content-middle">
                                        <div class="loader"></div> 
                                    </div>  
                                    <!--<iframe :src="link_photo" name="frame" id='iframe_dr' frameborder='0' v-show='active=="dr"'></iframe>-->
                                    <!-- <img id="sensor-img" :src="link_photo" style="margin: 0 auto; z-index: 9999; position: absolute; text-align:center;" width="1013"> -->
                                    <img id="sensor-img" :src="link_photo" width="1013">
                                    
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </transition>
    </div>



    <!--
    <div>
        <iframe src="" name="frame"></iframe>
        <p><a :href="link" target="frame">Open RDP</a></p>

        <button @click='changeLink'>Trocar link</button>
    </div>
    -->

</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'charts',
  data () {
    return {
        title: 'Photo Sensor',
        link_photo: '',
        sensor_photo: '',
        active: 'dr',
        showModal: false
    }
  },
  methods: {
      toggleLink(link){
          this.link = link;
      },
    ...mapGetters(['modal_photo'])
  },
  computed: {
    photoModal: function () {
        return this.modal_photo();
    },
  },
  watch: {
    show: function(newValue){
        this.showModal = newValue;
    },
    photoModal: function (newValue){
        this.link_photo = newValue.link_photo;
        this.sensor_photo = newValue.sensor_photo;
        this.showModal = true;
        this.active = 'dr';

        this.$nextTick(function () {
            this.$refs.closer.focus()
        })
    }
  },
  mounted(){
      this.link = this.link_photo;
      this.sensor_photo = this.sensor_photo;
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-header{
    height: 45px;
    align-items: center;
    align-content: center;
    color: white;
    margin-bottom: 10px;
}

.modal-body{
    margin: 0 auto;
    padding: 0;
    overflow: auto;
    /* max-height: 80vh;*/
    background-color: #2a2a2e!important;
}

.modal-dialog{
    width: 70vw;
    padding: 0;
}

.modal-content{
    padding: 0 20px;
    /* background: #1f1f20; */
    background: #2a2a2e;
    height: 90vh;
}

#close-button{
    outline: none;
    z-index: 10;
    margin-top: -15px;
    margin-right: -20px;
}

.ti-close{
    color: white;
    border-color: white;
    text-shadow: white;
}

.modal-title{
    color: white;
    font-weight: 100;
    font-size: 22px;
    margin: -10px 1px;
}

#iframe_dr, #iframe_feedback{
    width: 100%;
    height: 100%;
    /* margin: 55px auto; */
    position: relative;
    z-index: 2;
}

#buttons{
    /* height: 40px; */
    /* margin-top: -45px; */
    position: absolute;
    left: 35px;
    top: 45px;
}

.page-link{
    background: #343a40;
    border-color: #343a40;
    color: white;
    transition: background 0.4s;
    cursor: pointer;
    height: 35px;
}

.page-link:hover{
    background: #454d55;
}

#spinner-loading{
    position: relative;
	left: 50%;
	top: 50%;
	transform: translateY(-50%) translateX(-50%);
}

.loader {
    border: 6px solid #f3f3f3; /* Light grey */
    border-top: 6px solid #72b5e1; /* Blue */
    border-radius: 50%;
    width: 35px;
    height: 35px;
    animation: spin 2s linear infinite;
    margin: 0 auto;
    z-index: 1;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

#sensor-img{
	z-index: 9999;
	text-align: center;
	/*position: relative;
	left: 50%;
	top: 50%;
	transform: translateY(-50%) translateX(-50%);*/
    position: absolute;
    left: 0%;
    top: 0%;
	width: 100%;
}

@media screen and (max-width: 770px) {
    .modal-dialog {
        width: 90vw;
        padding: 0;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/photo_modal.vue